import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "history_active",
  "use": "history_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"history_active\"><path fill-rule=\"evenodd\" d=\"M9 6.765 1.91 3.428c-.5-.235-.91.02-.91.574v9.996c0 .546.407 1.194.91 1.43L9 18.765v-12Zm1 0 7.09-3.337c.503-.236.91.028.91.574v9.996c0 .553-.41 1.195-.91 1.43L10 18.765v-12ZM2 2h15L9.5 6 2 2Zm2 0h11L9.5 5 4 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol